<script lang="ts" setup>
import useReorderComponent from '@canvas-builder/composables/useReorderComponent'
import ReorderButton from '@canvas-builder/components/container/ControlBar/ReorderButton.vue'

withDefaults(
  defineProps<{
    disabled?: boolean
  }>(),
  {
    disabled: false,
  },
)

const { toggleContentVisibility } = useReorderComponent()
</script>

<template>
  <div class="control-bar-reorder">
    <ReorderButton :disabled="disabled" @click="toggleContentVisibility" />
  </div>
</template>
